/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2579
 */

var r = require(/* 2580 */"./2580")
var i = require(/* 1453 */"../../../../2570/1459/1181/1453")
var o = require(/* 993 */"../../../../../../../797/101/2466/1167/1435/993")
var a = i ? function (e, t) {
  return i(e, "toString", {
    configurable: true,
    enumerable: false,
    value: r(t),
    writable: true
  })
} : o
module.exports = a
